import { Box } from '@mui/material';
import { Body1, H3 } from '../typography';

export const InfoItem = ({ title, value }: { title?: string; value: string | number }) => (
  <Box sx={{ 
    py: 0.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
  }}>
    <Body1 sx={{ 
      color: (theme: any) => theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.6)'
        : 'rgba(0, 0, 0, 0.6)',
      fontSize: (theme: any) => theme.typography.fontSizes.body,
      fontWeight: 500,
    }}>
      {title}
    </Body1>
    <H3 sx={{ 
      fontWeight: 600,
      fontSize: (theme: any) => theme.typography.fontSizes.body,
    }}>
      {value || 'N/A'}
    </H3>
  </Box>
);